module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/cover-image-1887.f2632d6f9bd17e1c.jpg"+" 1887w",
        images: [{path: "https://static.sniffspot.com/packs/img/cover-image-1887.f2632d6f9bd17e1c.jpg",width: 1887,height: 1264}],
        src: "https://static.sniffspot.com/packs/img/cover-image-1887.f2632d6f9bd17e1c.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/cover-image-1887.f2632d6f9bd17e1c.jpg"},
        
        width: 1887,
        height: 1264
      }